var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_USER_ADMIN")
        ? _c("div", { staticClass: "col-md-10 pt-3" }, [
            _c(
              "form",
              {
                attrs: { autocomplete: "off" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.postData.userName,
                        expression: "postData.userName"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "userName",
                      placeholder: "例) 山田 太郎",
                      autocomplete: "userName",
                      required: ""
                    },
                    domProps: { value: _vm.postData.userName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.postData, "userName", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.postData.deletedAt,
                        expression: "!postData.deletedAt"
                      }
                    ],
                    staticClass: "notRetiree"
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "mail" } }, [
                        _vm._v("メールアドレス"),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _vm.invalidMail
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v("既に登録されています")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group col-md-6 p-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.postData.mailInput,
                              expression: "postData.mailInput"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "border-danger": _vm.invalidMail },
                          attrs: {
                            type: "mail",
                            id: "mail",
                            placeholder: "例) atmanage",
                            autocomplete: "nope",
                            required: ""
                          },
                          domProps: { value: _vm.postData.mailInput },
                          on: {
                            change: _vm.inputMail,
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.postData,
                                "mailInput",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "input-group-append",
                            staticStyle: {
                              "font-size": "1.2rem",
                              padding: "5px"
                            }
                          },
                          [_vm._v("@" + _vm._s(_vm.postData.domain))]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "password" } }, [
                        _vm._v("パスワード")
                      ]),
                      !_vm.edit
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v("*")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.invalidPassword
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "パスワードは6文字以上20文字以下で入力ください"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.edit
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.password,
                                expression: "postData.password"
                              }
                            ],
                            staticClass: "form-control",
                            class: { "border-danger": _vm.invalidPassword },
                            attrs: {
                              type: "password",
                              id: "password",
                              placeholder:
                                "任意。変更する場合はパスワードを入力ください",
                              autocomplete: "nope",
                              maxlength: "20"
                            },
                            domProps: { value: _vm.postData.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.postData,
                                  "password",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.password,
                                expression: "postData.password"
                              }
                            ],
                            staticClass: "form-control",
                            class: { "border-danger": _vm.invalidPassword },
                            attrs: {
                              type: "password",
                              id: "password",
                              placeholder: "パスワードを入力ください",
                              autocomplete: "nope",
                              maxlength: "20",
                              required: ""
                            },
                            domProps: { value: _vm.postData.password },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.postData,
                                  "password",
                                  $event.target.value
                                )
                              }
                            }
                          })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "unit" } }, [_vm._v("部署")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        _vm._l(_vm.departmentList, function(current) {
                          return _c(
                            "label",
                            { key: current.id, staticClass: "mr-1" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.postData.departmentIdList,
                                    expression: "postData.departmentIdList"
                                  }
                                ],
                                attrs: { type: "checkbox", name: "department" },
                                domProps: {
                                  value: current.id,
                                  checked: Array.isArray(
                                    _vm.postData.departmentIdList
                                  )
                                    ? _vm._i(
                                        _vm.postData.departmentIdList,
                                        current.id
                                      ) > -1
                                    : _vm.postData.departmentIdList
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.postData.departmentIdList,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = current.id,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.postData,
                                            "departmentIdList",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.postData,
                                            "departmentIdList",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.postData,
                                        "departmentIdList",
                                        $$c
                                      )
                                    }
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(current.departmentName) +
                                  "\n            "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("権限")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }, [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedRoleDefault,
                                expression: "selectedRoleDefault"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              name: "role",
                              value: "ROLE_USER",
                              disabled: "disabled",
                              checked: "checked"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.selectedRoleDefault)
                                ? _vm._i(_vm.selectedRoleDefault, "ROLE_USER") >
                                  -1
                                : _vm.selectedRoleDefault
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.selectedRoleDefault,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "ROLE_USER",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedRoleDefault = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedRoleDefault = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedRoleDefault = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(
                            "\n                      一般権限\n                  "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.hasAnyRole("ROLE_ADMIN")
                        ? _c("div", { staticClass: "checkbox" }, [
                            _c("label", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedRoleFull,
                                    expression: "selectedRoleFull"
                                  }
                                ],
                                attrs: {
                                  type: "checkbox",
                                  name: "role",
                                  id: "roleAdminCheck",
                                  value: "ROLE_ADMIN",
                                  disabled:
                                    _vm.postData.userId == _vm.loginUser.userId
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.selectedRoleFull)
                                    ? _vm._i(
                                        _vm.selectedRoleFull,
                                        "ROLE_ADMIN"
                                      ) > -1
                                    : _vm.selectedRoleFull
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.selectedRoleFull,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = "ROLE_ADMIN",
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectedRoleFull = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectedRoleFull = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectedRoleFull = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(3),
                              _vm._v(
                                "\n                      フル権限\n                  "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.advanced
                        ? _c("div", { attrs: { id: "roleOption" } }, [
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table table-bordered table-responsive"
                              },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _c("tbody", [
                                  _c("tr", { staticClass: "text-center" }, [
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRoleYukyu,
                                              expression: "selectedRoleYukyu"
                                            }
                                          ],
                                          staticClass: "custom-select",
                                          attrs: {
                                            id: "roleYukyu",
                                            name: "role"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedRoleYukyu = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                selected: "true"
                                              }
                                            },
                                            [_vm._v("なし")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_YUKYU_READ"
                                              }
                                            },
                                            [_vm._v("参照")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_YUKYU_ADMIN"
                                              }
                                            },
                                            [_vm._v("フル権限")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRoleKotsuhi,
                                              expression: "selectedRoleKotsuhi"
                                            }
                                          ],
                                          staticClass: "custom-select",
                                          attrs: {
                                            id: "roleKotsuhi",
                                            name: "role"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedRoleKotsuhi = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                selected: "true"
                                              }
                                            },
                                            [_vm._v("なし")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_KOTSUHI_READ"
                                              }
                                            },
                                            [_vm._v("参照")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_KOTSUHI_ADMIN"
                                              }
                                            },
                                            [_vm._v("フル権限")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRoleWork,
                                              expression: "selectedRoleWork"
                                            }
                                          ],
                                          staticClass: "custom-select",
                                          attrs: {
                                            id: "roleWork",
                                            name: "role"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedRoleWork = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                selected: "true"
                                              }
                                            },
                                            [_vm._v("なし")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "ROLE_WORK_READ" }
                                            },
                                            [_vm._v("参照")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_WORK_ADMIN"
                                              }
                                            },
                                            [_vm._v("フル権限")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRoleUser,
                                              expression: "selectedRoleUser"
                                            }
                                          ],
                                          staticClass: "custom-select",
                                          attrs: {
                                            id: "roleUser",
                                            name: "role"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedRoleUser = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                selected: "true"
                                              }
                                            },
                                            [_vm._v("なし")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: { value: "ROLE_USER_READ" }
                                            },
                                            [_vm._v("参照")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "ROLE_USER_ADMIN"
                                              }
                                            },
                                            [_vm._v("フル権限")]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectedRoleManage,
                                              expression: "selectedRoleManage"
                                            }
                                          ],
                                          staticClass: "custom-select",
                                          attrs: {
                                            id: "roleManage",
                                            name: "role"
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.selectedRoleManage = $event
                                                .target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            {
                                              attrs: {
                                                value: "",
                                                selected: "true"
                                              }
                                            },
                                            [_vm._v("なし")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "ROLE_MANAGE" } },
                                            [_vm._v("マネジメント権限")]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "togglebutton",
                          attrs: { id: "roleAdvance" }
                        },
                        [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.advanced,
                                  expression: "advanced"
                                }
                              ],
                              attrs: {
                                id: "roleOptionToggle",
                                type: "checkbox"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.advanced)
                                  ? _vm._i(_vm.advanced, null) > -1
                                  : _vm.advanced
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.advanced,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.advanced = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.advanced = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.advanced = $$c
                                  }
                                }
                              }
                            }),
                            _c("span", { staticClass: "toggle" }),
                            _vm._v("高度な設定\n                  ")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("シフト")]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.defaultWorkShiftId,
                                expression: "postData.defaultWorkShiftId"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { name: "defaultWorkShiftId" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.postData,
                                  "defaultWorkShiftId",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { domProps: { value: null } }, [
                              _vm._v("なし")
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.workShiftList, function(shift) {
                              return _c(
                                "option",
                                {
                                  key: shift.id,
                                  domProps: { value: shift.id }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(shift.name) +
                                      "\n                      "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("労働時間単位")]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.postData.defaultWorkTimeInterval,
                                expression: "postData.defaultWorkTimeInterval"
                              }
                            ],
                            staticClass: "custom-select",
                            attrs: { name: "defaultWorkTimeInterval" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.postData,
                                  "defaultWorkTimeInterval",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { selected: "true" } }, [
                              _vm._v("なし")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "0" } }, [
                              _vm._v("0")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "15" } }, [
                              _vm._v("15")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "30" } }, [
                              _vm._v("30")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "60" } }, [
                              _vm._v("60")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("入社日")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              placeholder: "入社日を入力してください"
                            },
                            model: {
                              value: _vm.postData.hireDate,
                              callback: function($$v) {
                                _vm.$set(_vm.postData, "hireDate", $$v)
                              },
                              expression: "postData.hireDate"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.postData.trainingMonth,
                            expression: "postData.trainingMonth"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "number",
                          placeholder: "デフォルトは0で登録されます",
                          required: ""
                        },
                        domProps: { value: _vm.postData.trainingMonth },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.postData,
                              "trainingMonth",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("緊急連絡先")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.postData.emergencyContact,
                            expression: "postData.emergencyContact"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          placeholder: "255文字まで自由記入",
                          maxlength: "255",
                          rows: "4"
                        },
                        domProps: { value: _vm.postData.emergencyContact },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.postData,
                              "emergencyContact",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.postData.outputWorkFilename,
                            expression: "postData.outputWorkFilename"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          placeholder: "例) {year}{month}_{name}_勤務表",
                          maxlength: "50"
                        },
                        domProps: { value: _vm.postData.outputWorkFilename },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.postData,
                              "outputWorkFilename",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", [_vm._v("生年月日")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group form-inline" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedYear,
                                expression: "selectedYear"
                              }
                            ],
                            staticClass: "form-control col-md-1",
                            attrs: { name: "birthday-yaer" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedYear = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.yearList, function(year) {
                            return _c(
                              "option",
                              { key: year, domProps: { value: year } },
                              [_vm._v(_vm._s(year))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "birthday-label",
                            attrs: { for: "birthday-year" }
                          },
                          [_vm._v("年")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedMonth,
                                expression: "selectedMonth"
                              }
                            ],
                            staticClass: "form-control col-md-1",
                            attrs: { name: "birthday-month" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedMonth = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(12, function(month, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: index } },
                              [_vm._v(_vm._s(month))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "birthday-label",
                            attrs: { for: "birthday-month" }
                          },
                          [_vm._v("月")]
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedDate,
                                expression: "selectedDate"
                              }
                            ],
                            staticClass: "form-control col-md-1",
                            attrs: { name: "birthday-date" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedDate = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.endOfMonth, function(date) {
                            return _c(
                              "option",
                              { key: date, domProps: { value: date } },
                              [_vm._v(_vm._s(date))]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "birthday-label",
                            attrs: { for: "birthday-date" }
                          },
                          [_vm._v("日")]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.postData.deletedAt
                  ? _c("div", [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("退職日")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(" *設定無しの場合、退職扱いではなくなります")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("el-date-picker", {
                              attrs: { type: "date" },
                              model: {
                                value: _vm.retireeDate,
                                callback: function($$v) {
                                  _vm.retireeDate = $$v
                                },
                                expression: "retireeDate"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary m-2",
                    attrs: { type: "button" },
                    on: { click: _vm.goUserList }
                  },
                  [_vm._v("戻る")]
                ),
                _vm._v(" "),
                _vm.edit
                  ? _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", value: "編集" }
                    })
                  : _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit", value: "登録" }
                    })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "dammy",
        staticStyle: {
          width: "0",
          height: "0",
          border: "none",
          position: "absolute",
          bottom: "0",
          "z-index": "-1"
        }
      },
      [
        _c("input", {
          staticStyle: { border: "none" },
          attrs: { type: "text" }
        }),
        _vm._v(" "),
        _c("input", {
          staticStyle: { border: "none" },
          attrs: { type: "password" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "userName" } }, [
      _vm._v("氏名"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("休暇申請管理")]),
        _vm._v(" "),
        _c("th", [_vm._v("交通費管理")]),
        _vm._v(" "),
        _c("th", [_vm._v("勤怠管理")]),
        _vm._v(" "),
        _c("th", [_vm._v("ユーザ管理")]),
        _vm._v(" "),
        _c("th", [_vm._v("マネジメント権限")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("研修期間（月数）"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("\n                勤怠ファイル名\n                "),
      _c(
        "button",
        {
          staticClass: "btn badge badge-info",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#help-modal"
          }
        },
        [_vm._v("\n                  説明\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "help-modal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "help-modal-label",
          "aria-hidden": "true"
        }
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "help-modal-label" }
                  },
                  [_vm._v("勤怠ファイル名の説明")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body p-3" }, [
                _c("p", [
                  _vm._v("空の場合、デフォルトのファイル名が使用されます。")
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("{}は任意です。{}内は置換されます。")]),
                _vm._v(" "),
                _c("p", [_vm._v("{}の使える種類は以下になります。")]),
                _vm._v(" "),
                _c("li", [_vm._v("{year}: 該当年で置換されます。")]),
                _vm._v(" "),
                _c("li", [_vm._v("{month}: 該当月で置換されます。")]),
                _vm._v(" "),
                _c("li", [_vm._v("{name}: 該当ユーザ氏名で置換されます。")])
              ])
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71d8531e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d8531e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/user/UserNewEdit.vue
// module id = 439
// module chunks = 0